export default "__VITE_ASSET__g3Zmdw5r__"